import removeAccents from 'remove-accents';

export function stripDia(value) {
	if (!value) {
		return value;
	}
	return removeAccents(value);
}


export function matchSrchTokens(tokens, srchStr) {
	if (!tokens || !srchStr) {
		return true;
	}
	return !tokens.some(token => srchStr.indexOf(token) < 0);
}




export function getSrchTokens(value) {
	if (typeof value === 'string') {
		value = value.trim();
		if (!value) {
			return [];
		}
		value = stripDia(value.toLowerCase());
		return value.split(/[^a-z0-9]+/).map(token => '/' + token);
	} else if (typeof value === 'number') {
		return ['/' + value];
	} else {
		return [];
	}
}

export function createSrchStr(rows) {
	return rows.map(row => {
		var srchStr = [];
		row.get('cells').forEach(cell => {
			getSrchTokens(cell).forEach(token => {
				srchStr.push(token);
			})
		});
		return row.set('srchStr', srchStr.join(''));
	});
}
